<!--SKU编辑  -->
<template>
	<div class="dialogBox">
		<el-dialog
			title="调整序号"
			v-if="dialogVisible"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			width="400px"
			:before-close="cancle"
		>
			<div>
				<div class="mt20 tc">
					{{ rowData.agentName }}
				</div>
				<div class="mt20 flex sort-box">
					<div>
						{{ weekObj[deliveryCycle] }}：{{ oldDeliverSort }}-->
					</div>
					<el-input
						class="w50 ml5"
						v-model.trim="deliverSort"
						maxlength="3"
					></el-input>
				</div>
			</div>

			<span slot="footer" class="dialog-footer mt10">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { debounce } from "@/utils/debounce";
export default {
	data() {
		return {
			dialogVisible: false,
			rowData: {},
			// 原序号
			oldDeliverSort: '',
			// 序号
			deliverSort: "",
			// 周期 例：周一
			deliveryCycle: "",
			weekObj: {
				'': '全部',
				'1': '周一',
				'2': '周二',
				'3': '周三',
				'4': '周四',
				'5': '周五',
				'6': '周六',
				'0': '周日',
			},
			weekSortKey: {
				'': 'deliverSort',
				'1': 'monSort',
				'2': 'tuesSort',
				'3': 'wedSort',
				'4': 'thurSort',
				'5': 'friSort',
				'6': 'satSort',
				'0': 'sunSort',
			}
		};
	},
	created() {},
	methods: {
		init(rowData, deliveryCycle) {
			this.$nextTick(() => {
				this.dialogVisible = true;
				this.deliverSort = "";
				if (rowData) {
					this.rowData = rowData;
					this.deliveryCycle = deliveryCycle;
					this.oldDeliverSort = rowData[this.weekSortKey[deliveryCycle]];
				}
			});
		},
		//  设置序号
		setSort() {
			if (this.deliverSort == "") {
				this.$message.error("序号不能为空");
				return;
			}
			if (this.deliverSort == 0) {
				this.$message.error("序号不能为0");
				return;
			}
			if (/^[0-9]*$/.test(this.deliverSort)) {
				let that = this;
				that.$request
					.post("routeMapUpdateSort", false, {
						id: that.rowData.id,
						deliverSort: that.deliverSort,
						deliveryCycle: that.deliveryCycle
					})
					.then(res => {
						if (res.code == '0') {
							that.$message.success('调整序号成功！');
							that.dialogVisible = false;
							that.$emit("getList");
						}
					});
			} else {
				this.$message.error("请输入整数");
			}
		},
		// 保存
		submitForm: debounce(
			function() {
				this.setSort();
			},
			1000,
			true
		),
		// 取消
		cancle() {
			this.dialogVisible = false;
		}
	},
	beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.dialogBox {
	/deep/ .el-dialog__body {
		padding: 0px 10px;
	}

	/deep/ .el-radio .el-radio__label {
		display: none;
	}
}

.dialogBox {
	/deep/ .el-dialog__body {
		height: 130px !important;
	}
}

.w50 {
	width: 60px;
}

.sort-box {
	justify-content: center;
	line-height: 40px;
	font-size: 16px;
}
</style>
